import { render, staticRenderFns } from "./BlockMenu.vue?vue&type=template&id=2720aca4&"
import script from "./BlockMenu.vue?vue&type=script&lang=js&"
export * from "./BlockMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports